import {Box, Stack, Container, Typography} from '@mui/material';
import Timer from '../Timer'

export default function TopBar({width, myTime, setMyTime, turn, color, inverse, onExport, gameState, setResignConfirmation, opponentName}) {

    return (
        <Box
        
        sx={{
            borderRadius: 3,
            flexShrink: 0,
            boxShadow: 1,
            width: {width},
            height: 60,
            backgroundColor: '#36454F',
        }}
      >
            <Container
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                }}
            >
                <Stack direction='row' spacing={width/10 - 16}>

                    {/* <Typography variant="h4" color='white'> {String(turn && gameState === 'start')} </Typography> */}
                    <Timer minSecs={myTime} setTime={setMyTime} isRunning={turn && gameState === 'start'} inverse={inverse}/>
                    <Typography variant='h5' sx={{display:'flex', alignSelf:'center'}}> {opponentName} </Typography>

                </Stack>
            </Container>
        </Box>

    )


}